module.exports = __webpack_public_path__ + "img/carshina22_29.75ec89c8.jpg";